import React, { useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { GET_OPLEIDING_LIST } from "../graphql/queries";
import gsap from "gsap";

export default function Opleiding() {
    const { loading, error, data } = useQuery(GET_OPLEIDING_LIST);
    const opleidingItemsRefs = useRef([]);

    useEffect(() => {
        if (!loading && !error && data) {
            opleidingItemsRefs.current.forEach((itemRef, index) => {
                gsap.fromTo(
                    itemRef,
                    { opacity: 0, y: 20 },
                    { opacity: 1, y: 0, duration: 1, delay: index * 0.2 }
                );
            });
        }
    }, [loading, error, data]);

    if (loading) return <p>Loading...</p>;
    if (error) {
        console.error(error);
        return <p>Error: {error.message}</p>;
    }

    return (
        <div className="main-container">
            <div className="posts-header">
                <div className="post-content">
                    <h1>
                        Hoe ziet onze
                        <br />
                        opleiding eruit?
                    </h1>
                    <div className="purple-line"></div>
                    <p>
                        In het Graduaat Programmeren leer je programmeren en
                        staat front-end web development centraal. Jouw lessen
                        worden doorspekt met interactieve oefeningen. Je krijgt
                        opdrachten om nieuwe leerstof snel onder de knie te
                        krijgen. Werkplekleren en jouw stage zijn samen goed
                        voor meer dan 1.200 uur aan praktijkervaring. Hierna ben
                        je meer dan klaar voor de arbeidsmarkt.
                    </p>
                </div>
                <ul className="opleidingen op-header">
                    {data.opleidings.map((item, index) => (
                        <div key={index} className="opleiding-item">
                            <li>
                                <a href={`#${item.title}`}>{item.title}</a>
                            </li>
                        </div>
                    ))}
                </ul>
            </div>
            <div className="opleidingen">
                {data.opleidings.map((item, index) => (
                    <div
                        key={index}
                        className="opleiding-card"
                        id={item.title}
                        ref={(el) => (opleidingItemsRefs.current[index] = el)}
                    >
                        <div className="top-line"></div>
                        <h2>{item.title}</h2>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
